var _defs, _line, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFMobileLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ba0cb372-455c-4c58-9fe2-81142d4c0faf",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 94.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.af6c39ed-0ad9-4311-bbdd-b260d5677033{fill:none;stroke:#777;stroke-width:0.75px;}.aac06aff-d2f8-40b1-8c6d-5437eb5166ce{fill:#777; stroke-width:0.75px;}\n"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "ed94499a-bc2a-46f8-aa71-d8dfaa47affd",
    "data-name": "Line 9",
    className: "af6c39ed-0ad9-4311-bbdd-b260d5677033 svg-line",
    x1: 4.5,
    x2: 4.5,
    y2: 85.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a1765eb4-ccad-4f4e-a2b9-97e3e128dc25",
    "data-name": "Ellipse 4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "aac06aff-d2f8-40b1-8c6d-5437eb5166ce svg-line",
    cx: 4.5,
    cy: 90,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "af6c39ed-0ad9-4311-bbdd-b260d5677033",
    cx: 4.5,
    cy: 90,
    r: 4.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFMobileLine);
export default __webpack_public_path__ + "static/media/F-Mobile-Line.8c19a451d6d10d421721f63ea1e9cefa.svg";
export { ForwardRef as ReactComponent };